"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.KansaRegisterResult = void 0;
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _ActionMessage = _interopRequireDefault(require("01_core/components/materials/ActionMessage"));
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _APIs = require("01_core/constants/APIs");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _CRadarChart = _interopRequireDefault(require("32_kansa/common/components/materials/CRadarChart"));
var _KansaTgtJigyoBasicInfo = _interopRequireDefault(require("32_kansa/common/components/materials/KansaTgtJigyoBasicInfo"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _CardActions = _interopRequireDefault(require("@mui/material/CardActions"));
var _CardContent = _interopRequireDefault(require("@mui/material/CardContent"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _FollowupList = _interopRequireDefault(require("../kansaResultRefer/components/FollowupList"));
var _KansaKekkaJissiDate = _interopRequireDefault(require("../kansaResultRefer/components/KansaKekkaJissiDate"));
var _KansaKekkaJissiPlace = _interopRequireDefault(require("../kansaResultRefer/components/KansaKekkaJissiPlace"));
var _KansaKekkaSokatsu = _interopRequireDefault(require("../kansaResultRefer/components/KansaKekkaSokatsu"));
var _ReferReportInfo = _interopRequireDefault(require("../kansaResultRefer/components/ReferReportInfo"));
var _SeijukudoComment = _interopRequireDefault(require("../kansaResultRefer/components/SeijukudoComment"));
var _ShoninDate = _interopRequireDefault(require("../kansaResultRefer/components/ShoninDate"));
var _ShoninshaName = _interopRequireDefault(require("../kansaResultRefer/components/ShoninshaName"));
var _SogoHyoka = _interopRequireDefault(require("../kansaResultRefer/components/SogoHyoka"));
var _KakuninjikoList = _interopRequireDefault(require("./components/KakuninjikoList"));
var _kansaResultRegisterActions = require("./kansaResultRegisterActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * 監査結果登録結果画面
 */
class KansaRegisterResult extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      maxPoints: 0
    };
    const {
      kansaInfo,
      callAPI
    } = this.props;
    const sendData = {
      kansaTgtNendo: kansaInfo.kansaTgtNendo,
      kansaTgtJigyoId: kansaInfo.kansaTgtJigyoId
    };
    // 確認事項一覧取得
    callAPI(_APIs.KANSA_RESULT_KAKUNINJIKO, sendData).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        this.props.setFollowupList(response.data.followupList);
        this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
          maxPoints: response.data.maxPoints
        }));
      }
    });
    this.props.setkansaTgtJigyoBasicInfo(this.props.kansaTgtJigyoBasicInfo);
    this.props.setGoodpointList(this.props.goodpointList);
    this.props.setkaizenList(this.props.kaizenList);
    this.props.setFutekigoList(this.props.futekigoList);
    this.props.setSeijukudo(this.props.seijukudo);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const {
      entries,
      returnBtn,
      intl,
      getCodeName,
      kansaTgtJigyoBasicInfo,
      followupList,
      goodpointList,
      kaizenList,
      futekigoList,
      seijukudo,
      mailErrMsg
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
      title: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_RESULT_RESULT_TITLE
      })
    }, /*#__PURE__*/_react.default.createElement(_CardContent.default, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 1.5
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 8
      },
      align: "left",
      sx: {
        mb: '10px'
      }
    }, /*#__PURE__*/_react.default.createElement(_ActionMessage.default, {
      action: "register",
      supplement: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", {
        style: {
          whiteSpace: 'pre-wrap'
        }
      }, mailErrMsg))
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 4
      },
      align: "right",
      sx: {
        mb: '10px'
      }
    }, returnBtn()), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 1,
      component: "div"
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_ReferReportInfo.default, {
      reportDate: entries.reportDate,
      reportDestNm: entries.reportDestNm
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_KANSA_BUMON
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_ShoninDate.default, {
      shoninDate: entries.shoninDate
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_ShoninshaName.default, {
      shoninshaNm: entries.shoninshaNm
    })))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_RESULT_GAIYO
      })
    }), /*#__PURE__*/_react.default.createElement(_KansaTgtJigyoBasicInfo.default, {
      data: kansaTgtJigyoBasicInfo
    })), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_RESULT_KEKKA_SOKATSU
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_SogoHyoka.default, {
      sogohyoka: entries.sogohyoka
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_KansaKekkaJissiDate.default, {
      naibukansaJissiDt: entries.naibukansaJissiDt
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_KansaKekkaJissiPlace.default, {
      naibukansaJissiPlace: entries.naibukansaJissiPlace
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 7
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_KansaKekkaSokatsu.default, {
      sokatsu: entries.sokatsu
    }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        paddingTop: 8
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_RESULT_ZENNENDO_FOLLOWUP
      })
    })), followupList.length !== 0 ? /*#__PURE__*/_react.default.createElement(_FollowupList.default, {
      followupList: followupList
    }) : /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2",
      sx: {
        color: 'rgb(49, 71, 218)'
      }
    }, intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_RESULT_FOLLOWUP_NODATA
    }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        paddingTop: 8
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_RESULT_HONNENDO_GOODPOINT
      })
    })), goodpointList.length !== 0 ? /*#__PURE__*/_react.default.createElement(_KakuninjikoList.default, {
      list: goodpointList
    }) : /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2",
      sx: {
        color: 'rgb(49, 71, 218)'
      }
    }, intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_RESULT_HONNENDO_NODATA
    }, {
      0: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_RESULT_HONNENDO_GOODPOINT
      })
    }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        paddingTop: 8
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_RESULT_HONNENDO_KAIZEN
      })
    })), kaizenList.length !== 0 ? /*#__PURE__*/_react.default.createElement(_KakuninjikoList.default, {
      list: kaizenList
    }) : /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2",
      sx: {
        color: 'rgb(49, 71, 218)'
      }
    }, intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_RESULT_HONNENDO_NODATA
    }, {
      0: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_RESULT_HONNENDO_KAIZEN
      })
    }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        paddingTop: 8
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_RESULT_HONNENDO_FUTEKIGO
      })
    })), futekigoList.length !== 0 ? /*#__PURE__*/_react.default.createElement(_KakuninjikoList.default, {
      list: futekigoList
    }) : /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2",
      sx: {
        color: 'rgb(49, 71, 218)'
      }
    }, intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_RESULT_HONNENDO_NODATA
    }, {
      0: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_RESULT_HONNENDO_FUTEKIGO
      })
    }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, seijukudo.length !== 0 ? /*#__PURE__*/_react.default.createElement(_CRadarChart.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_SEJUKUDO_HYOKA
      }),
      chartHeight: 450,
      chartWidth: 650,
      domainMax: this.state.maxPoints,
      tickCount: this.state.maxPoints + 2,
      radarAttr: [{
        name: getCodeName(_CodeConsts.CODE.KANSA_GYOMU_CD.KBN, _CodeConsts.CODE.KANSA_GYOMU_CD.CODE_1),
        key: 'score',
        color: '#FF0000'
      }],
      chartData: seijukudo,
      dataKey: "chosaColumnNm"
    }) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_SEJUKUDO_HYOKA
      })
    }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2",
      sx: {
        color: 'rgb(49, 71, 218)'
      }
    }, intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_RESULT_SEJUKUDO_NODATA
    })))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 8
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_SeijukudoComment.default, {
      kansabumonComment: entries.kansabumonComment
    })))), /*#__PURE__*/_react.default.createElement(_CardActions.default, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: '100%',
        textAlign: 'right'
      }
    }, returnBtn())))));
  }
}
exports.KansaRegisterResult = KansaRegisterResult;
const mapStateToProps = state => {
  return {
    entries: state.kansaResultRegister.entries,
    kansaInfo: state.kansaResultRegister.kansaInfo,
    registerDt: state.kansaResultRegister.registerDt,
    kansaTgtJigyoBasicInfo: state.kansaResultRegister.kansaTgtJigyoBasicInfo,
    followupList: state.kansaResultRegister.followupList,
    goodpointList: state.kansaResultRegister.goodpointList,
    kaizenList: state.kansaResultRegister.kaizenList,
    futekigoList: state.kansaResultRegister.futekigoList,
    seijukudo: state.kansaResultRegister.seijukudo,
    mailErrMsg: state.kansaResultRegister.mailErrMsg
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setkansaTgtJigyoBasicInfo: kansaTgtJigyoBasicInfo => dispatch(_kansaResultRegisterActions.kansaResultRegisterActions[_kansaResultRegisterActions.TYPES_REG.SET_KANSATGTJIGYOBASICINFO](kansaTgtJigyoBasicInfo)),
    setFollowupList: followupList => dispatch(_kansaResultRegisterActions.kansaResultRegisterActions[_kansaResultRegisterActions.TYPES_REG.SET_FOLLOWUPLIST](followupList)),
    setGoodpointList: goodpointList => dispatch(_kansaResultRegisterActions.kansaResultRegisterActions[_kansaResultRegisterActions.TYPES_REG.SET_GOODPOINTLIST](goodpointList)),
    setkaizenList: kaizenList => dispatch(_kansaResultRegisterActions.kansaResultRegisterActions[_kansaResultRegisterActions.TYPES_REG.SET_KAIZENLIST](kaizenList)),
    setFutekigoList: futekigoList => dispatch(_kansaResultRegisterActions.kansaResultRegisterActions[_kansaResultRegisterActions.TYPES_REG.SET_FUTEKIGOLIST](futekigoList)),
    setSeijukudo: seijukudo => dispatch(_kansaResultRegisterActions.kansaResultRegisterActions[_kansaResultRegisterActions.TYPES_REG.SET_SEIJUKUDO](seijukudo))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _CodeUtil.withCodeUtil)((0, _reactRedux.connect)(mapStateToProps)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)(KansaRegisterResult)))));